<template>
  <main class="page-operative page-operative-data-analysis page-operative-data-analysis-investimenti page-operative-data-analysis-investimenti-new">
    <div class="container">
      <div class="d-flex align-items-center justify-content-between mb-5">
        <PageTitle>Nuovo investimento</PageTitle>
        <app-router-link class="btn btn-outline-primary" :to="{ name: 'operative-company.data-analysis.investimenti' }">Torna alla lista</app-router-link>
      </div>
      <FormInvestimento @saved="saveInvestimento" />
    </div>
  </main>
</template>

<script>

import operativePageMixin from '../../../../../mixins/operativePage';

export default {
  name: 'page-operative-company-data-analysis-investimenti-new',
  mixins: [operativePageMixin],
  components: {
    PageTitle: () => import('../../../../components/Layout/LayoutOperative/PageTitle'),
    FormInvestimento: () => import('../../../../components/Operative/Form/FormInvestimento'),
    AppRouterLink: () => import('../../../../components/Layout/AppRouterLink'),
  },
  methods: {
    saveInvestimento (investimento) {
      this.$api.addInvestimento(this.company.id, investimento)
        .then(() => {
          this.$router.push({
            name: 'operative-company.data-analysis.investimenti',
            query: {
              forecast: this.$route.query?.forecast || null,
            },
          });
        })
        .catch(this.$log.error)
      ;
    },
  },
};

</script>
